export default {"src":"/_next/static/media/turtle.7ab7194f.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};